import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes,  Route, } from 'react-router-dom';
// import PrivateRoute from './utils/PrivateRoute'
import PrivateRoute from './context/PrivateRoute'
import { AuthProvider } from './context/AuthContext';
import { ApiProvider } from './context/ApiContext';
import UserAccount from './pages/UserAccount';


import Page2 from './pages/page2';
import Home from './pages/Home';
// import JobListings from './pages/JobListings';
import Page404 from './pages/Page404';
import OpportunityDetails from './pages/OpportunityDetails';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Apply from './pages/Apply';
import PostOpportunity from './pages/PostOpportunity';
import Register from './pages/Register';
import CommunityVenturePortfolio from './pages/CommunityVenturePortfolio';
import CVPLIstings from './pages/CVPLIstings';
import OpportunityListings from './pages/OpportunityListings';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
// import UserAccount from './pages/UserAccount';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <React.StrictMode>
      <ApiProvider>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/opportunity-listings/:opportunity_type/" element={<OpportunityListings />} />
            <Route path="/opportunity-details/:id/:title" element={<OpportunityDetails />} />
            <Route path="/apply/:id/:title" element={<Apply />} />
            <Route path="/page2" element={<Page2 />} />
            <Route path="/community-venture-portfolio" element={<CommunityVenturePortfolio />} />
            <Route path="/cvp/:company_name/:sector" element={<CVPLIstings />} />

            {/* Private Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/post-opportunity" element={<PostOpportunity />} />
              {/* <Route path="/user-account" element={<UserAccount />} /> */}
            </Route>

            {/* 404 fallback */}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </AuthProvider>
      </ApiProvider>
    </React.StrictMode>
  </Router>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
